import {
  ALMOST_THERE_INFO,
  OLD_SIGNATORIES_KEYS,
  OLD_ACCOUNT_DETAILS_INFO,
  OTHER_KEY,
  LIMITED_LIB_PARTNERSHIP,
  SOLE_TRADER
} from '../../utils/constants';
import { oldSignatoriesSelector } from '.';
import { selectors as caseSelector } from '../cases';

const TYPE_CUSTOMER = 'CUSTOMER';
const TYPE_OFFICER = 'OFFICER';
const TYPE_PRIM = 'PRIM';
const TYPE_JOIN = 'JOIN';
const LEGAL_STATUS_PCLS = 'PCLS';
const LEGAL_STATUS_LLPP = 'LLPP';
export const generateMicroenterprisePayload = (state, isSoleTrader, switchDate) => {
  let request = {
    new_business_customer: getBusinessCustomerId(state),
    switch_type: oldSignatoriesSelector.isCurrentAccountSwitch(state) ? 'FULL' : 'PART',
    complete_date: getCompleteDate(switchDate),
    new_account: getNewAccountDetails(state),
    old_account: getOldAccountDetails(state, isSoleTrader)
  };
  request = isSoleTrader
    ? Object.assign({}, request, getCustomerInfo(state))
    : Object.assign({}, request, getAccountParty(state));
  if (!switchDate) {
    delete request.complete_date;
  }
  const sourceId = getSourceId(state);
  if (sourceId !== null) {
    request.source_id = sourceId;
  }
  return JSON.stringify(request);
};

export const getSourceId = state => {
  const caseData = state.dataCapture.get('caseData');
  return caseData.source_id ? caseData.source_id : null;
};

export const getBusinessCustomerId = state => {
  const completedResponse = oldSignatoriesSelector.getBusinessData(state, ALMOST_THERE_INFO);
  if (completedResponse && completedResponse.customer && completedResponse.customer.id) {
    return Object.assign(
      {},
      {
        id: completedResponse.customer.id,
        type: completedResponse.customer.type
      },
      getLegalStatus(state)
    );
  }
  return {};
};

export const getNewAccountDetails = state => {
  const completedResponse = oldSignatoriesSelector.getBusinessData(state, ALMOST_THERE_INFO);
  if (completedResponse && completedResponse.account) {
    return completedResponse.account;
  }
  return {};
};

export const getOldAccountDetails = (state, isSoleTrader) => {
  const oldAccount = oldSignatoriesSelector.getBusinessData(state, OLD_ACCOUNT_DETAILS_INFO);
  if (oldAccount && oldAccount.name) {
    return Object.assign(
      {},
      {
        name: oldAccount.name,
        debit_card: false,
        sort_code: Object.values(oldAccount.oldSortCode).join(''),
        account_number: oldAccount.account_number
      },
      getDebitCardDetails(oldAccount, isSoleTrader)
    );
  }
  return {};
};

const getDebitCardDetails = (oldAccount, isSoleTrader) => {
  let debitCardDetails = {};
  const SUBSTRING_INDEX = 4;
  if (isSoleTrader && oldAccount.debitCardQuestion === 'Yes') {
    if (oldAccount.expiryDate.dateField) {
      delete oldAccount.expiryDate.dateField;
    }
    const expDate = oldAccount.expiryDate;
    const yearField = expDate.yearField.substring(2, SUBSTRING_INDEX);
    debitCardDetails = {
      debit_card: true,
      card: {
        number: oldAccount.cardNumber,
        expiry_date: `${expDate.monthField}${yearField}`
      }
    };
  }
  return debitCardDetails;
};

export const getAccountParty = state => {
  const signatories = oldSignatoriesSelector.getBusinessData(state, OLD_SIGNATORIES_KEYS);
  if (signatories && signatories.length > 0) {
    return {
      account_party: signatories.map(signatory => {
        const applicant = {
          party_type: signatory.isPrimary ? TYPE_CUSTOMER : TYPE_OFFICER,
          id: caseSelector.getPersonalCustomerId(state),
          title: getTitle(signatory),
          first_name: signatory.firstName,
          middle_name: signatory.middleName,
          last_name: signatory.lastName,
          dob: getDateOfBirth(signatory.dob),
          //below needs to be captured for all account parties.
          nationality: getNationality(signatory),
          country_of_residence: getCountryOfResidence(signatory),
          relationship_type: signatory.isPrimary ? TYPE_PRIM : TYPE_JOIN
        };
        if (!signatory.isPrimary) {
          delete applicant.id;
        }
        if (!signatory.middleName) {
          delete applicant.middle_name;
        }
        return applicant;
      })
    };
  }
  return [];
};

const getDateOfBirth = dob => `${dob.yearField}-${dob.monthField}-${dob.dateField}`;

const getCustomerInfo = state => {
  return {
    customer_info: oldSignatoriesSelector.getCustomerNationality(state)
  };
};

const getNationality = signatory =>
  signatory.nationality && signatory.nationality === OTHER_KEY
    ? signatory.nationalityOther
    : signatory.nationality;

const getCountryOfResidence = signatory =>
  signatory.country_of_residence && signatory.country_of_residence === OTHER_KEY
    ? signatory.countryOther
    : signatory.country_of_residence;

const getTitle = signatory => {
  if (signatory.title && signatory.title.toLowerCase() === 'other') {
    return signatory.titleOther.toUpperCase();
  }
  return signatory.title.toUpperCase();
};

const getCompleteDate = date =>
  date
    ? date
        .format('DD/MM/YYYY')
        .split('/')
        .reverse()
        .join('')
    : '';

const getLegalStatus = state => {
  const variant = caseSelector.getVariant(state);
  if (variant) {
    if (variant.toLowerCase() === LIMITED_LIB_PARTNERSHIP) {
      return { legal_status: LEGAL_STATUS_LLPP };
    } else if (variant.toLowerCase() !== SOLE_TRADER) {
      return { legal_status: LEGAL_STATUS_PCLS };
    }
  }
  return {};
};
